import Vue from 'vue/dist/vue.esm'

Vue.component(
  'pdf-viewer-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/files/PdfViewer")
)